import { BadgeCheck, ShieldAlert, Clock, Upload } from "lucide-react";

/**
 * VerifiedBadgeChip — single trust chip shown on public-facing surfaces.
 *
 * Shows only: Verified ADI | Verified PDI | Pending Verification | Needs update | Expired.
 * NEVER shows raw card numbers or photos.
 */
export default function VerifiedBadgeChip({ verification, size = "sm", className = "" }) {
  if (!verification) return null;
  const { state, chip_label, badge_type } = verification;

  const cls = size === "lg" ? "text-sm px-3 py-1.5" : "text-[11px] px-2 py-0.5";
  const icon = size === "lg" ? "w-4 h-4" : "w-3 h-3";

  if (state === "verified_adi" || state === "verified_pdi") {
    const color = badge_type === "adi"
      ? "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-900/30 dark:text-emerald-200 dark:border-emerald-800"
      : "bg-pink-100 text-pink-800 border-pink-300 dark:bg-pink-900/30 dark:text-pink-200 dark:border-pink-800";
    return (
      <span data-testid={`verified-chip-${state}`} className={`inline-flex items-center gap-1 font-extrabold rounded-full border ${cls} ${color} ${className}`}>
        <BadgeCheck className={icon} /> {chip_label}
      </span>
    );
  }

  if (state === "pending_review") {
    return (
      <span data-testid="verified-chip-pending" className={`inline-flex items-center gap-1 font-extrabold rounded-full border bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 ${cls} ${className}`}>
        <Clock className={icon} /> Pending Verification
      </span>
    );
  }

  if (state === "expired" || state === "needs_update") {
    return (
      <span data-testid={`verified-chip-${state}`} className={`inline-flex items-center gap-1 font-extrabold rounded-full border bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-800 ${cls} ${className}`}>
        <ShieldAlert className={icon} /> {chip_label}
      </span>
    );
  }

  // not_uploaded
  return (
    <span data-testid="verified-chip-none" className={`inline-flex items-center gap-1 font-bold rounded-full border bg-white text-slate-500 border-slate-200 dark:bg-slate-900 dark:text-slate-400 dark:border-slate-700 ${cls} ${className}`}>
      <Upload className={icon} /> Not uploaded
    </span>
  );
}
